// Chore particle themes — drives the floating touch-to-pop animation layer.
export const CHORE_THEMES = {
  washing_up: {
    label: "Washing up",
    emojis: ["🫧", "🫧", "🧼", "🫧"],
    color: "#3B82F6",
    bg: "#E0F2FE",
  },
  gardening: {
    label: "Gardening",
    emojis: ["🍃", "🌿", "🍂", "🌱"],
    color: "#10B981",
    bg: "#D1FAE5",
  },
  pet_litter: {
    label: "Pet litter",
    emojis: ["💩", "🐾", "💩", "🐕"],
    color: "#B45309",
    bg: "#FEF3C7",
  },
  bins: {
    label: "Bins & trash",
    emojis: ["📄", "🪳", "🪰", "🗑️"],
    color: "#4B5563",
    bg: "#E5E7EB",
  },
  vacuuming: {
    label: "Vacuuming",
    emojis: ["✨", "⭐", "💫", "✨"],
    color: "#FBBF24",
    bg: "#FEF9C3",
  },
  laundry: {
    label: "Laundry",
    emojis: ["🧦", "👕", "✨", "🧺"],
    color: "#EC4899",
    bg: "#FCE7F3",
  },
};

export const THEME_KEYS = Object.keys(CHORE_THEMES);

export const ROLE_COLORS = {
  mom: "#FF5A8B",
  dad: "#8B5CF6",
  kid: "#10B981",
};

export const fmtMoney = (n) => `$${Number(n || 0).toFixed(2)}`;
